import { useHandler } from "@chatbotgang/etude/react/useHandler";
import Stack from "@mui/material/Stack";
import { useMemo, useState } from "react";

import { TopupFilterBar } from "@/pages/billing/v2/tabs/usageDetails/TopupFilterBar";
import { TopupTable } from "@/pages/billing/v2/tabs/usageDetails/TopupTable";
import type { TopupFilters } from "@/pages/billing/v2/tabs/usageDetails/utils";
import { getDefaultDateRange } from "@/pages/billing/v2/tabs/usageDetails/utils";

export const UsageDetailsTab: React.FC = function UsageDetailsTab() {
  const defaultRange = useMemo(() => getDefaultDateRange(), []);

  const [filters, setFilters] = useState<TopupFilters>({
    dateFrom: defaultRange.dateFrom,
    dateTo: defaultRange.dateTo,
    status: null,
  });

  const handleFiltersChange = useHandler((newFilters: TopupFilters) => {
    setFilters(newFilters);
  });

  return (
    <Stack gap="16px">
      <TopupFilterBar filters={filters} onFiltersChange={handleFiltersChange} />
      <TopupTable filters={filters} />
    </Stack>
  );
};
